var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('app-header',{attrs:{"id":"header"}}),(_vm.notification!=null)?_c('app-message',{attrs:{"id":"message","message":_vm.notification}}):_vm._e(),_c('router-view'),_c('app-footer',{attrs:{"id":"footer"}})],1),_c('div',{attrs:{"id":"fill"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }